<template>
  <div id="app">
    <ConfigProvider :locale="zhCN">
      <router-view />
    </ConfigProvider>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { ConfigProvider } from 'ant-design-vue'
export default {
  components: { ConfigProvider },
  data() {
    return {
      zhCN
    }
  },
  mounted() {
    document.title = '设备管理平台'
  }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  height: 100%;
  // min-width: 1366px;
  // overflow: auto;
  overflow-y: hidden;
}

.content-warp {
  padding: 16px;
  overflow-y: auto !important;
  position: absolute !important;
  bottom: 0;
  top: 88px;
  left: 0;
  right: 0;
}
.content-panle {
  border-radius: 5px;
  padding: 16px;
}
.content-panle .panle-head:before {
  content: '';
  margin-right: 10px;
  border: 2px solid #1890ff;
  border-radius: 5px;
}
.content-panle > .gutter-row > .panle-item {
  background-color: #fff;
  padding: 16px;
  min-height: 670px;
  border-radius: 5px;
  box-shadow: 0 0 20px #e8e8e8;
}

.search-form {
  text-align: right;
  flex-grow: 1;
  margin: 12px 0;
}

.table-tip-btn {
  padding: 0 0;

  button {
    margin-right: 10px;
  }
}
.table-tip-btn:before{
  content: "";
  margin-right: 10px;
  border-left: 1px solid #d9d9d9;
}

.content-panle .table-area {
  min-height: 544px;
}
.content-panle .table-area .operation-botton {
  border-right: 1px solid #ddd;
  padding: 0 5px;
}
.content-panle .table-area .operation-botton[disabled] {
  opacity: 0.4;
  cursor: not-allowed;
}
.content-panle .table-area .operation-botton:last-child {
  border: none;
}

.form-select {
  z-index: 8 !important;
  text-align: left;
}
.form-date-picker {
  z-index: 8 !important;
}

.ant-table-placeholder {
  border-bottom: unset !important;
}

.bg-white {
  background-color: #fff;
  box-shadow: 0 0 20px #e8e8e8;
}
.margin-0 {
  margin: 0 !important;
}
.margin-bottom-lg {
  margin-bottom: 20px !important;
}

.padding-0 {
  padding: 0 !important;
}
.padding-tb-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.padding-tb-md {
  padding-top: 12px;
  padding-bottom: 12px;
}

.text-danger {
  color: #ff4d4f ;
}
.text-warning {
  color: #faad14 ;
}
.text-success {
  color: #52c41a ;
}
.text-primary {
  color: #108ee9 ;
}
.text-gray {
  color: #c1c1c1  ;
}

.text-left{
  text-align: left;
}
.text-right{
  text-align: right;
}

// .scroll-selection {
//   margin-top: 4px !important;

//   .ant-select-selection--multiple{
//     overflow-x: auto;
//     // overflow-y: hidden;
//     cursor: pointer;
//     .ant-select-selection__rendered{
//       width: max-content;
//       min-width: 100%
//     }

//     ul {
//       width: max-content;
//     }
//   }
// }

// Button 颜色
.ant-btn.ant-btn-warning {
  color: #fff;
  background-color: #faad14;
  border-color: #faad14;
  text-shadow: unset;
  box-shadow: unset;

  // text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  // box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
}
.ant-btn.ant-btn-warning:hover, .ant-btn.ant-btn-warning:focus {
  color: #fff;
  background-color: rgba(250,173,20,0.8);
  border-color: rgba(250,173,20,0.8);
}

</style>
